module.exports = __webpack_public_path__ + "img/logo-woocommerce.f95a6c30.png";